export const getSnsTopics = () => {
  return [
    {
      ARN: "arn:aws:sns:us-east-1:123456789012:dynamodb",
      AccountNumber: "123456789012",
      Apps: [],
      Departments: [],
      DisplayName: "",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "1a617174-0dd1-41ed-a5c7-1b65ca57bad7",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "123456789012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:123456789012:dynamodb","Condition":{"StringEquals":{"AWS:SourceOwner":"123456789012"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:123456789012:dynamodb",
      ResourceName: "dynamodb",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:123456789012:dynamodb",
    },
    {
      ARN: "arn:aws:sns:us-east-1:987654321098:aws-controltower-SecurityNotifications",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-SecurityNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "1eb103e0-4456-4ddc-93a8-8810a39e0eeb",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:987654321098:aws-controltower-SecurityNotifications","Condition":{"StringEquals":{"AWS:SourceOwner":"987654321098"}}},{"Sid":"TrustCWEToPublishEventsToMyTopic","Effect":"Allow","Principal":{"Service":"events.amazonaws.com"},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-1:987654321098:aws-controltower-SecurityNotifications"}]}',
      RegionCode: "us-east-1",
      ResourceId:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-SecurityNotifications",
      ResourceName: "aws-controltower-SecurityNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "1",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-SecurityNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-1:562783538012:Venkat_At_MC_DAY2App_Notification",
      AccountNumber: "562783538012",
      Apps: [],
      Departments: [],
      DisplayName: "Venkat_At_MC_DAY2App_Notification",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "24532dd7-eda0-4d6f-912e-bfab653c2643",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "562783538012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:562783538012:Venkat_At_MC_DAY2App_Notification","Condition":{"StringEquals":{"AWS:SourceOwner":"562783538012"}}}]}',
      RegionCode: "us-east-1",
      ResourceId:
        "arn:aws:sns:us-east-1:562783538012:Venkat_At_MC_DAY2App_Notification",
      ResourceName: "Venkat_At_MC_DAY2App_Notification",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "2",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-1:562783538012:Venkat_At_MC_DAY2App_Notification",
    },
    {
      ARN: "arn:aws:sns:us-east-1:123456789012:Test",
      AccountNumber: "123456789012",
      Apps: [],
      Departments: [],
      DisplayName: "test",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "294af77d-1ff2-44a2-ab5d-8e8a361af7ed",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "123456789012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:123456789012:Test","Condition":{"StringEquals":{"AWS:SourceOwner":"123456789012"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:123456789012:Test",
      ResourceName: "Test",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:123456789012:Test",
    },
    {
      ARN: "arn:aws:sns:us-east-2:562783538012:MGMNT-Ohio",
      AccountNumber: "562783538012",
      Apps: [],
      Departments: [],
      DisplayName: "MGMNT-Ohio",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "5288b98f-ef8c-4af9-828f-aa3160199ef8",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "562783538012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish"],"Resource":"arn:aws:sns:us-east-2:562783538012:MGMNT-Ohio","Condition":{"StringEquals":{"AWS:SourceOwner":"562783538012"}}}]}',
      RegionCode: "us-east-2",
      ResourceId: "arn:aws:sns:us-east-2:562783538012:MGMNT-Ohio",
      ResourceName: "MGMNT-Ohio",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-2:562783538012:MGMNT-Ohio",
      TracingConfig: "PassThrough",
    },
    {
      ARN: "arn:aws:sns:us-east-2:051908244533:aws-controltower-SecurityNotifications",
      AccountNumber: "051908244533",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-SecurityNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "5c966569-4291-452d-bb3c-ad39bbf0cc67",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "051908244533",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-2:051908244533:aws-controltower-SecurityNotifications","Condition":{"StringEquals":{"AWS:SourceOwner":"051908244533"}}},{"Sid":"TrustCWEToPublishEventsToMyTopic","Effect":"Allow","Principal":{"Service":"events.amazonaws.com"},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-2:051908244533:aws-controltower-SecurityNotifications"}]}',
      RegionCode: "us-east-2",
      ResourceId:
        "arn:aws:sns:us-east-2:051908244533:aws-controltower-SecurityNotifications",
      ResourceName: "aws-controltower-SecurityNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "1",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-2:051908244533:aws-controltower-SecurityNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-1:051908244533:FBP001-Virginia",
      AccountNumber: "051908244533",
      Apps: [],
      Departments: [],
      DisplayName: "FBP001-Virginia",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "5f14385b-f814-45e6-97c8-50c91c715124",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "051908244533",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish"],"Resource":"arn:aws:sns:us-east-1:051908244533:FBP001-Virginia","Condition":{"StringEquals":{"AWS:SourceOwner":"051908244533"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:051908244533:FBP001-Virginia",
      ResourceName: "FBP001-Virginia",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:051908244533:FBP001-Virginia",
      TracingConfig: "PassThrough",
    },
    {
      ARN: "arn:aws:sns:us-east-1:341308857630:Log-Virginia",
      AccountNumber: "341308857630",
      Apps: [],
      Departments: [],
      DisplayName: "Log-Virginia",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "68453964-91c7-4893-b850-c8114296ddf6",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "341308857630",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish"],"Resource":"arn:aws:sns:us-east-1:341308857630:Log-Virginia","Condition":{"StringEquals":{"AWS:SourceOwner":"341308857630"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:341308857630:Log-Virginia",
      ResourceName: "Log-Virginia",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:341308857630:Log-Virginia",
      TracingConfig: "PassThrough",
    },
    {
      ARN: "arn:aws:sns:us-east-2:987654321098:aws-controltower-AggregateSecurityNotifications",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-AggregateSecurityNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "6a694d0f-644d-463d-98d2-b477cf963af7",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-2:987654321098:aws-controltower-AggregateSecurityNotifications","Condition":{"StringEquals":{"AWS:SourceOwner":"987654321098"}}},{"Sid":"AWSSNSPolicy","Effect":"Allow","Principal":{"AWS":"*"},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-2:987654321098:aws-controltower-AggregateSecurityNotifications","Condition":{"StringEquals":{"aws:PrincipalOrgID":"o-4lvue3i8mc"}}}]}',
      RegionCode: "us-east-2",
      ResourceId:
        "arn:aws:sns:us-east-2:987654321098:aws-controltower-AggregateSecurityNotifications",
      ResourceName: "aws-controltower-AggregateSecurityNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-2:987654321098:aws-controltower-AggregateSecurityNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-1:987654321098:aws-controltower-AggregateSecurityNotifications",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-AggregateSecurityNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "8177af4c-2133-4553-a6c9-a3cd33c4b404",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:987654321098:aws-controltower-AggregateSecurityNotifications","Condition":{"StringEquals":{"AWS:SourceOwner":"987654321098"}}},{"Sid":"AWSSNSPolicy","Effect":"Allow","Principal":{"AWS":"*"},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-1:987654321098:aws-controltower-AggregateSecurityNotifications","Condition":{"StringEquals":{"aws:PrincipalOrgID":"o-4lvue3i8mc"}}}]}',
      RegionCode: "us-east-1",
      ResourceId:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-AggregateSecurityNotifications",
      ResourceName: "aws-controltower-AggregateSecurityNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-AggregateSecurityNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-2:987654321098:Audit-Ohio",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "Audit-Ohio",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "a0dcbefe-4e6a-4ecf-b390-b2d1a553e4ce",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish"],"Resource":"arn:aws:sns:us-east-2:987654321098:Audit-Ohio","Condition":{"StringEquals":{"AWS:SourceOwner":"987654321098"}}}]}',
      RegionCode: "us-east-2",
      ResourceId: "arn:aws:sns:us-east-2:987654321098:Audit-Ohio",
      ResourceName: "Audit-Ohio",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "1",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-2:987654321098:Audit-Ohio",
      TracingConfig: "PassThrough",
    },
    {
      ARN: "arn:aws:sns:us-east-1:562783538012:MGMNT-Virginia",
      AccountNumber: "562783538012",
      Apps: [],
      Departments: [],
      DisplayName: "MGMNT-Virginia",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "a3150238-8f9b-49ca-9504-1e611229ca32",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "562783538012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish"],"Resource":"arn:aws:sns:us-east-1:562783538012:MGMNT-Virginia","Condition":{"StringEquals":{"AWS:SourceOwner":"562783538012"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:562783538012:MGMNT-Virginia",
      ResourceName: "MGMNT-Virginia",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:562783538012:MGMNT-Virginia",
      TracingConfig: "PassThrough",
    },
    {
      ARN: "arn:aws:sns:us-east-1:987654321098:aws-controltower-AllConfigNotifications",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-AllConfigNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "abf05fad-5827-4861-8206-4c18aa6bed1d",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"AWSSNSPolicy","Effect":"Allow","Principal":{"Service":["cloudtrail.amazonaws.com","config.amazonaws.com"]},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-1:987654321098:aws-controltower-AllConfigNotifications"}]}',
      RegionCode: "us-east-1",
      ResourceId:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-AllConfigNotifications",
      ResourceName: "aws-controltower-AllConfigNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-1:987654321098:aws-controltower-AllConfigNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-2:987654321098:aws-controltower-AllConfigNotifications",
      AccountNumber: "987654321098",
      Apps: [],
      Departments: [],
      DisplayName: "aws-controltower-AllConfigNotifications",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "b1e8bbab-330f-4990-9eeb-9058c5dcfbef",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "987654321098",
      Policy:
        '{"Version":"2008-10-17","Statement":[{"Sid":"AWSSNSPolicy","Effect":"Allow","Principal":{"Service":["config.amazonaws.com","cloudtrail.amazonaws.com"]},"Action":"sns:Publish","Resource":"arn:aws:sns:us-east-2:987654321098:aws-controltower-AllConfigNotifications"}]}',
      RegionCode: "us-east-2",
      ResourceId:
        "arn:aws:sns:us-east-2:987654321098:aws-controltower-AllConfigNotifications",
      ResourceName: "aws-controltower-AllConfigNotifications",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn:
        "arn:aws:sns:us-east-2:987654321098:aws-controltower-AllConfigNotifications",
    },
    {
      ARN: "arn:aws:sns:us-east-1:562783538012:MC_Cross_Account_SNS",
      AccountNumber: "562783538012",
      Apps: [],
      Departments: [],
      DisplayName: "MCCross",
      EffectiveDeliveryPolicy:
        '{"http":{"defaultHealthyRetryPolicy":{"minDelayTarget":20,"maxDelayTarget":20,"numRetries":3,"numMaxDelayRetries":0,"numNoDelayRetries":0,"numMinDelayRetries":0,"backoffFunction":"linear"},"disableSubscriptionOverrides":false,"defaultRequestPolicy":{"headerContentType":"text/plain; charset=UTF-8"}}}',
      ID: "b219d627-4d6c-4236-8ef8-dd353e7be958",
      OrganizationId: "8deba6a6-38f8-4a5c-8700-4942e280b2a9",
      Owner: "562783538012",
      Policy:
        '{"Version":"2008-10-17","Id":"__default_policy_ID","Statement":[{"Sid":"__default_statement_ID","Effect":"Allow","Principal":{"AWS":"*"},"Action":["SNS:GetTopicAttributes","SNS:SetTopicAttributes","SNS:AddPermission","SNS:RemovePermission","SNS:DeleteTopic","SNS:Subscribe","SNS:ListSubscriptionsByTopic","SNS:Publish","SNS:Receive"],"Resource":"arn:aws:sns:us-east-1:562783538012:MC_Cross_Account_SNS","Condition":{"StringEquals":{"AWS:SourceOwner":"562783538012"}}}]}',
      RegionCode: "us-east-1",
      ResourceId: "arn:aws:sns:us-east-1:562783538012:MC_Cross_Account_SNS",
      ResourceName: "MC_Cross_Account_SNS",
      ResourceType: "Topic",
      SubscriptionsConfirmed: "0",
      SubscriptionsDeleted: "0",
      SubscriptionsPending: "0",
      Tags: [],
      TopicArn: "arn:aws:sns:us-east-1:562783538012:MC_Cross_Account_SNS",
    },
  ];
};
